import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Users } from "lucide-react";

export default function ClientSwitcher({ clients, activeId, onChange, disabled = false }) {
  return (
    <div className="clinical-card p-4 flex items-center gap-3" data-testid="client-switcher">
      <div className="h-11 w-11 rounded-md bg-primary/10 text-primary flex items-center justify-center shrink-0">
        <Users className="w-5 h-5" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-label">Active Client</p>
        <Select value={activeId || ""} onValueChange={onChange} disabled={disabled}>
          <SelectTrigger className="border-0 px-0 h-auto text-lg font-display font-semibold focus:ring-0 shadow-none" data-testid="client-switcher-trigger">
            <SelectValue placeholder="Select a client" />
          </SelectTrigger>
          <SelectContent>
            {clients.map((c) => (
              <SelectItem key={c.id} value={c.id} data-testid={`client-option-${c.id}`}>
                {c.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
